import { Directive, ElementRef, Inject, OnInit } from '@angular/core';
import { style } from '../utils/style.utils';
import { componentStylesByTheme } from '../utils/theme.utils';
import { THEME_TOKEN, Theme } from '../types/theme.types';
import { avatarStylesSAG, avatarStylesSHS } from './avatar.styles';

@Directive({
  selector: '[sag-ui-avatar]',
})
export class AvatarDirective implements OnInit {
  constructor(
    @Inject(THEME_TOKEN) private readonly theme: Theme,
    private readonly elementRef: ElementRef<HTMLInputElement>
  ) {}

  ngOnInit(): void {
    const styles = componentStylesByTheme(
      this.theme,
      avatarStylesSAG,
      avatarStylesSHS
    );
    style(this.elementRef, styles());
  }
}
